export const NAMESPACE = 'lana-lana-ai';
export const FILTER_NAMESPACE = 'lana/lana-ai';
export const AI_SIDEBAR_NAME = `${NAMESPACE}/lana-ai-sidebar`;
export const FORMAT_NAME = `${NAMESPACE}/learn-more-link`;
export const INTERACTIVITY_STORE_NAME = 'lana-ai-audio';
